import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { RouterMap } from '@tangilla/tg-ng-core';

const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: RouterMap.Auth.MAINTENANCE,
        loadChildren: () => import('./maintenance/maintenance.module').then(m => m.MaintenanceModule),
      },
      {
        path: 'forms/v1/f/:id',
        loadChildren: () => import('./portal/portal.module').then(m => m.PortalModule),
      },
      {
        path: ':id',
        loadChildren: () => import('./portal/portal.module').then(m => m.PortalModule),
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
